import React from "react";
import "../assets/css/Leaderboard.scss";
import StatCard from "../components/Dashboard/StatCard";
import compicon from "../assets/images/competetionicon.svg";
import fundingicon from "../assets/images/fundingicon.svg";
import lossicon from "../assets/images/lossicon.svg";
import winicon from "../assets/images/winicon.svg";
import { Grid } from "@mui/material";
import Title from "../components/ReusableComponents/title";
import * as ReactBootstrap from "react-bootstrap";
import AwardFirst from "../assets/images/AwardFirst.svg";
import { Link } from "react-router-dom";
import CompetetionBanner from "../components/Dashboard/CompetetionBanner";
import { Carousel } from "react-responsive-carousel";

const LeaderboardMobile = () => {
  const LeaderBoard = [
    {
      id: 1,
      award: <img src={AwardFirst} alt="" />,
      Name: "Snow",
      Date: "10 Jan, 2022",
      AccoountSize: "$400,000",
      Challenge: "$200K",
      Prizewon: "Macbook Pro",
    },
    {
      id: 1,
      award: <img src={AwardFirst} alt="" />,
      Name: "Snow",
      Date: "10 Jan, 2022",
      AccoountSize: "$400,000",
      Challenge: "$200K",
      Prizewon: "Macbook Pro",
    },
  ];

  const renderLeaderBoard = (leaderboard, index) => {
    return (
      <tr key={index}>
        <td>{leaderboard.id}</td>
        <td>{leaderboard.award}</td>
        <td>{leaderboard.Name}</td>
        <td>{leaderboard.Prizewon}</td>
      </tr>
    );
  };

  return (
    <div className="LeaderboardMobileBox">
      <Grid className="SectionL" xs={12} sm={12} md={12}>
        <div className="d-grid gapp-20">
          <Grid container className="gapp-20 Sec">
            <Grid className="LeaderBStat">
              <StatCard
                StatName="Competition"
                StatDetail="50 Competition "
                StatIcon={compicon}
              />
            </Grid>
            <Grid className="LeaderBStat">
              <StatCard
                StatName="Total Funding"
                StatDetail="$ 20,750.00"
                StatIcon={fundingicon}
              />
            </Grid>
          </Grid>
          <Grid container className="gapp-20 Sec">
            <Grid className="LeaderBStat">
              <StatCard
                StatName="Pariticipated"
                StatDetail="3052 Challenger"
                StatIcon={lossicon}
              />
            </Grid>
            <Grid className="LeaderBStat">
              <StatCard
                StatName="Total Winner"
                StatDetail="750 Winner"
                StatIcon={winicon}
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
      <div className="LBMLast">
        <Grid className="Container-p-20 mtt-20 SectionL sectionsecond">
          <div className="d-flex justify-content-between">
            <h1 className="mbb-10 Section-Head">Leaderboard</h1>
            <Link to="/Leaderboard">
              <div className="Link">See All</div>
            </Link>
          </div>
          <div className="LeaderBM">
            <ReactBootstrap.Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th></th>
                  <th>Name</th>
                  <th>Prize won</th>
                </tr>
              </thead>
              <tbody>{LeaderBoard.map(renderLeaderBoard)}</tbody>
            </ReactBootstrap.Table>
          </div>
        </Grid>
        <Grid container className="mtt-20 SectionL sectionlast">
          <Carousel
            showArrows={false}
            showStatus={false}
            className="CompetetionCarousel"
          >
            <CompetetionBanner
              HeadDate="December 2023"
              CompName="Trading Competition"
              Prize="1st prize"
              PrizedGood="Macbook Pro"
              Challenge="200K Challenge"
              FromDatte="01 March 2022"
              ToDate="31 March 2022"
            />

            <CompetetionBanner
              HeadDate="January 2022"
              CompName="Trading Competition"
              Prize="1st prize"
              PrizedGood="Macbook Pro"
              Challenge="200K Challenge"
              FromDatte="01 March 2022"
              ToDate="31 March 2022"
            />

            <CompetetionBanner
              HeadDate="March 2022"
              CompName="Trading Competition"
              Prize="1st prize"
              PrizedGood="Macbook Pro"
              Challenge="200K Challenge"
              FromDatte="01 March 2022"
              ToDate="31 March 2022"
            />
          </Carousel>
        </Grid>
      </div>
    </div>
  );
};

export default LeaderboardMobile;
